import React, { Fragment } from 'react';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import NoSSR from '~/components/NoSSR';
import Nav from '~/components/Nav/Nav';
import Footer from '~/components/Footer/Footer';

const Toast = dynamic(() => import(/* webpackChunkName: "Toast.Toast.components" */'../Toast/Toast'), { ssr: false, loading: () => null });

const GdprBanner = dynamic(() => import(/* webpackChunkName: "Gdpr.GdprBanner.components" */'../Gdpr/GdprBanner'), { loading: () => null });

const Content = styled.div`
  transition: all 0.5s ease-in-out;
  ${props => !props.isPartner && `
    padding-top: 56px;
    @media only screen and (max-width: 1024px){
      padding-top: ${((props.extraPadding) ? 90 : 48)}px;
    }
  `};
  ${props => props.isPartner && `
    padding-top: 80px;
    @media(max-width: 600px) {
      padding-top: ${props.extraPadding ? 98 : 56}px;
    }
  `};
`;

// const enhance = connect(
//   state => ({
//     isLoggedIn: state.session.isLoggedIn,
//     user: state.session.user,
//     isPartner: state.app.isPartner,
//     partnerConfig: state.app.partnerConfig,
//   })
// );

const Layout = (props) => {
  const isLoggedIn = useSelector(state => state.session.isLoggedIn);
  const user = useSelector(state => state.session.user);
  const partnerConfig = useSelector(state => state.app.partnerConfig);

  return (
    <Fragment>
      <Nav url={props.url} />
      <Content extraPadding={isLoggedIn && user.is_local_expert} isPartner={!isEmpty(partnerConfig)}>
        {props.children}
      </Content>
      <NoSSR>
        <Toast />
        <Footer />
        <GdprBanner />
      </NoSSR>
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
  url: PropTypes.object,
};

export default Layout;
